module.exports = __webpack_public_path__ + "img/p4-info.fe154e7d.jpg";